import PoissonDiskSampling from "poisson-disk-sampling";

interface PoissonConfig {
    size: [number, number];
    minDistance: number;
    maxDistance: number;
    tries: number;
}

interface CachedPoints {
    config: PoissonConfig;
    points: number[][];
    generated: number;
}


export async function getOrGeneratePoissonPoints(
    size: [number, number],
    minDistance: number,
    maxDistance: number,
    tries: number,
): Promise<number[][]> {
    const fileName = `poisson_${size[0]}_${size[1]}_${minDistance}_${maxDistance}_${tries}.json`;

    // get file?
    try {
        const response = await fetch(`/src/data/${fileName}`);
        if (response.ok) {
            const data: CachedPoints = await response.json();

            // verify config matches
            if (
                data.config.size[0] === size[0] &&
                data.config.size[1] === size[1] &&
                data.config.minDistance === minDistance &&
                data.config.maxDistance === maxDistance &&
                data.config.tries === tries
            ) {

                return data.points;
            }
        }
    } catch (error) {}


    // make new points if no file
    const poisson = new PoissonDiskSampling({
        shape: size,
        minDistance,
        maxDistance,
        tries,
    });

    const points = poisson.fill();
    console.debug("Had to generate poisson points")

    return points;
}


export function downloadPoissonPoints(
    points: number[][],
    config: PoissonConfig,
) {
    const data: CachedPoints = {
        config,
        points,
        generated: Date.now(),
    };

    const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `poisson_${config.size[0]}_${config.size[1]}_${config.minDistance}_${config.maxDistance}_${config.tries}.json`;
    link.click();
    URL.revokeObjectURL(url);
}
